export default [
  {
    path: '/quick-message',
    name: 'quick-message',
    component: () => import('@/views/quickMessage/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.updateQuickMessage',
      navActiveLink: 'quick-message',
      resource: 'chat-settings',
      action: 'manage',
      breadcrumb: [
        {
          text: 'breadcrumb.updateQuickMessage',
          active: true,
        },
      ],
    },
  },
]
